import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=a49ff572&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./Setting.vue?vue&type=script&lang=js&"
export * from "./Setting.vue?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=a49ff572&prod&scoped=true&lang=scss&"
import style1 from "./Setting.vue?vue&type=style&index=1&id=a49ff572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49ff572",
  null
  
)

export default component.exports